import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { listRecommendations, decideRecommendation } from '../lib/db.js';
import { useAuth } from '../lib/auth.jsx';
import { StatusBar } from '../components/StatusBar.jsx';
import { BottomNav } from '../components/BottomNav.jsx';
import { baht } from '../lib/severance.js';

const TYPE = {
  salary_increase: { label: 'ขึ้นเงินเดือน', icon: '↑' },
  promotion: { label: 'เลื่อนตำแหน่ง', icon: '⇧' },
  bonus: { label: 'โบนัส', icon: '✦' },
};
const DECISION = { approved: 'อนุมัติ', deferred: 'พักไว้', declined: 'ปฏิเสธ' };

export function Recommendations() {
  const nav = useNavigate();
  const { appUser } = useAuth();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [flash, setFlash] = useState('');

  useEffect(() => {
    listRecommendations().then(setRows).catch((e) => { setErr(e.message); setRows([]); });
  }, []);

  const decision = (r) => r.manager_decision || r.status;
  const pending = (rows || []).filter((r) => decision(r) === 'pending').length;

  async function decide(r, d) {
    try {
      await decideRecommendation(r.id, d, appUser?.id);
      setRows((prev) => prev.map((x) => (x.id === r.id ? { ...x, status: d, manager_decision: d } : x)));
      setFlash(`${DECISION[d]} — ${name(r)} · บันทึกผู้ตัดสิน + audit`);
      setTimeout(() => setFlash(''), 2600);
    } catch (e) { setErr(e.message); }
  }

  return (
    <div className="phone">
      <StatusBar />
      <section className="screen">
        <button className="back" onClick={() => nav(-1)}>‹ กลับ</button>
        <div className="title-row">
          <div><div className="eyebrow">ระบบแนะนำ · มนุษย์ตัดสิน</div><h1 className="page">ข้อเสนอ</h1></div>
          <span className="glyph">✦</span>
        </div>

        {err && <p className="err">{err}</p>}
        {!rows && <div className="center"><div className="spinner" /></div>}

        {rows && (
          <>
            <div className="hero"><div className="num">{pending}</div><div className="sub">ข้อเสนอที่รอตัดสินใจ</div></div>
            {flash && <div className="leave-note"><b>{flash}</b></div>}
            <hr className="hr" />
            {rows.map((r) => {
              const t = TYPE[r.type] || { label: r.type, icon: '•' };
              const d = decision(r);
              return (
                <div className="card" key={r.id}>
                  <div className="row" style={{ paddingTop: 0, border: 0 }}>
                    <div className="ic">{t.icon}</div>
                    <div className="main">
                      <div className="l1">{name(r)} — {t.label}</div>
                      <div className="l2">{r.position || ''}{r.suggested_value ? ` · เสนอ ${baht(r.suggested_value)}` : ''}</div>
                    </div>
                    {d !== 'pending' && <span className={`tag ${d === 'approved' ? 'ok' : d === 'declined' ? 'warn' : 'pend'}`}>{DECISION[d]}</span>}
                  </div>
                  <div className="note" style={{ marginTop: 6 }}>เหตุผลที่ระบบแนะนำ: {r.basis}</div>
                  {d === 'pending' && (
                    <div className="btn-row">
                      <button className="b-ok" onClick={() => decide(r, 'approved')}>อนุมัติ</button>
                      <button className="b-no" onClick={() => decide(r, 'deferred')}>พักไว้</button>
                      <button className="b-no" onClick={() => decide(r, 'declined')}>ปฏิเสธ</button>
                    </div>
                  )}
                </div>
              );
            })}

            <Link to="/severance"><button className="cta ghost" style={{ marginTop: 22 }}>🧮 เครื่องคำนวณค่าชดเชย (เลิกจ้าง)</button></Link>
          </>
        )}
      </section>
      <BottomNav />
    </div>
  );
}

const name = (r) => r.emp_name || (r.employees ? (r.employees.nickname || r.employees.first_name) : '');
